import { render, staticRenderFns } from "./campaginOption.vue?vue&type=template&id=38c61854&scoped=true&"
import script from "./campaginOption.vue?vue&type=script&lang=js&"
export * from "./campaginOption.vue?vue&type=script&lang=js&"
import style0 from "./campaginOption.vue?vue&type=style&index=0&id=38c61854&lang=scss&scoped=true&"
import style1 from "./campaginOption.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c61854",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
